module.exports = __webpack_public_path__ + "static/media/landslide.3d00376f.svg";